import { sendAxiosRequest } from "@api/request.js";

// brands
async function getBrands() {
  const url = `${import.meta.env.VITE_API_BASE_URL}/api/brands`;

  const config = {
    method: "get",
    url: url,
    headers: {
      Accept: "*/*",
    },
  };

  return await sendAxiosRequest(config);
}

export {
  // brands
  getBrands,
};
